module.exports = __webpack_public_path__ + "media/assets/img/company/Logo_Agglo_Basque-e524e1e3f3dbc9b164d658762d6665a1.png";